import { useNavigate } from 'react-router-dom'
import { HandlerErrorMessage } from '../utils/HandlerErrorMessage'
import { Rotas } from 'routes/rotas'
import useUserInfoStore from 'store/useUser'
import { UserPrivileges } from 'types/usuario'
import { useSnackbarAlertContext } from 'contexts/SnackbarContext'

export const useHandlerPrivileges = () => {
  const navigate = useNavigate()
  const { privilegios } = useUserInfoStore((state) => state)
  const { showAlert } = useSnackbarAlertContext()

  const handlerPrivileges = (privilegeItem: keyof UserPrivileges) => {
    const privilege = privilegios[privilegeItem]

    if (!privilege) {
      HandlerErrorMessage({
        showAlert,
        customErrorMessage: 'Erro ao verificar as permissões, faça o login novamente.'
      })
      navigate(Rotas.LOGIN)
    } else if (privilege === 'N') {
      HandlerErrorMessage({
        showAlert,
        customErrorMessage: 'Sem permissão de acessar essa tela.'
      })
      navigate(Rotas.MENU)
    }
  }

  return handlerPrivileges
}
